import browserHydrateFunction from "./src/utilities/browser-hydrate-function";
import "./src/styles/global.css";

export const replaceHydrateFunction = browserHydrateFunction;
